<template>
  <div>
    <select class="select-status"  v-model="selectedStatus"  @change="handleChange">
      <option :value="null">Рабочий Статус</option>
      <option v-for="status in statusList" :key="status.id" :value="status.id">{{ status.name }}</option>
    </select>
  </div>
</template>
  
<script>
import ApiConnector from '@/backend/apiModels/userApi';
import { ref, onMounted } from 'vue';

export default {
  name: 'work-status-filter',
  props: {
    value: String, // Принимаем значение из родительского компонента через v-model
  },
  setup(props, { emit }) {
    const api = new ApiConnector();
    const { response, request } = api.get('/trips/status', {});
    const statusList = ref([]);
    const selectedStatus = ref(null);

    const getStatus = async () => {
      await request();
      statusList.value = response.value;
    };

    onMounted(getStatus);

    const handleChange = () => {
      // Отправляем событие в родительский компонент
      emit('update:modelValue', selectedStatus.value);
    };

    return {
      statusList,
      selectedStatus,
      handleChange,
    };
  },
};
</script>


<style scoped>
.select-status{
  background-color: white;
  border: none;
  border-bottom: 1px solid #ccc;
  padding: 5px; 
  width: 177px;
}
</style>